import { trackYouLeadPage } from "./track-event"

// YouLead hash-link tracking: records in-page navigation triggered by anchor hashes
// (e.g. #section links) so YouLead sees the extended page value.
document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (event) => {
    const link = event.target.closest('a[href*="#"]')

    if (!link) {
      return
    }

    const hash = link.href.split("#")[1]

    if (!hash) {
      return
    }

    trackYouLeadPage(hash)
  })
})
